import styled from "./construct/styled"
import animated from "./AnimatedComponent"
import construct from "./construct"
import css from "./construct/css"

export default styled(
  animated,
  construct
)

export { css }
